// expandable items
$('.expandable-items .item .item__toggle').on('click', function (e) {
    e.preventDefault();

    let $toggle = $(this),
        $item = $toggle.closest('.item'),
        toggledClass = 'item--toggled';

    if ($item.hasClass(toggledClass)) {
        $item.removeClass(toggledClass);
    } else {
        $item.addClass(toggledClass);
    }
});
